import React, { useEffect, useRef, useState } from "react";
import MainHeader from "../../Components/MainHeader/MainHeader";
import { AppFooter } from "../LandingPage/Components/Footer/Footer";
import LogoGallery from "../LandingPage/Components/Logo/Logos";
import {
  Typography,
  Row,
  Col,
  Space,
  Card,
  Button,
  Image,
  Breadcrumb,
  Table,
} from "antd";
import InvestBgi from "@assets/KPMG/Invest.png";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode, Navigation, Thumbs } from "swiper";
import {
  PercentageOutlined,
  StarOutlined,
  EnvironmentOutlined,
  HomeOutlined,
} from "@ant-design/icons";
import AccordionTable from "./Components/Accordian";
import styles from "./InvestmentHub.module.scss";
import { Fade } from "react-awesome-reveal";
import { InvestmentHubData } from "../../mocks/MockData";
import DjuandaWater from "@assets/KPMG/assets/DjuandaWater.png";
import BinhDuong from "@assets/KPMG/assets/BinhDuong.png";
import plant from "@assets/KPMG/assets/plant.png";
import reserve from "@assets/KPMG/assets/reserve.png";
import ConnectingDots from "@assets/KPMG/connectingDots.svg";
import CircleInCircle from "@assets/KPMG/circleInCircle.svg";
import { Icon } from "@iconify/react";
import RelatedProjects from "./Components/RelatedPosts";
import { useNavigate, useParams } from "react-router-dom";
import InvestImg from "@assets/KPMG/Invest.png";
import { Cell, Label, Pie, PieChart } from "recharts";
import { getRandomBoolean } from "~/Utils/CommonUtils";
import type { ColumnsType } from "antd/es/table";
import { DetailView } from "./Components/DetailView";
import ImageList from "~/Components/ImageGallery/ImageGallery";
import { isEmpty } from "lodash";

const getRandomImage = () => {
  const images = [DjuandaWater, BinhDuong, plant, reserve];
  const randomIndex = Math.floor(Math.random() * images.length);
  return images[randomIndex];
};

export const InvestmentDetailView = () => {
  const [thumbsSwiper, setThumbsSwiper] = useState(null);
  const [relatedRecords, setRelatedRecords] = useState<any>([]);
  const [filteredItem, setFilteredItem] = useState<any>({});
  const [images, setImages] = useState<any>([]);
  const navigate = useNavigate();
  const { id } = useParams();
  let filteredProjects;
  const ref = useRef<HTMLDivElement>(null);

  const test = (record: any) => {
    return (
      <div>
        <p>testing</p>
      </div>
    );
  };

  const [panelList, setPanelList] = useState<any>([]);
  const data = useEffect(() => {
    let item = InvestmentHubData.find((item) => item.key === id);
    updateImages(item);
    setFilteredItem(item);
    if (item) {
      let records = InvestmentHubData.filter(
        (item: any) =>
          item.categories[0].name === item.categories[0].name &&
          item.key !== item.key
      );
      setRelatedRecords(records);
      if (isEmpty(item.concessionPeriod)) {
        item.concessionPeriod = "10";
      }
      let data: any = [
        {
          key: 0,
          title: "Overview",
          data: [
            {
              title: "Estimated Project Cost",
              value: item.EstimatedProjectCost,
            },
            {
              title: "Financial Feasibility",
              value: !item.financialFeasibility || (item.financialFeasibility.irr === "Not Disclosed" && item.financialFeasibility.npv === "Not Disclosed")
              ? "Not Disclosed"
              : item,
              // value: "Upstream Phase\nIRR: 10,7%\nNPV: USD 33.87 Million",
            },
            // {
            //   title: "Upstream Phase",
            //   value: "IRR: 10,7%\nNPV: USD 33.87 Million",
            // },
            // {
            //   title: "Downstream Phase – DKI Jakarta",
            //   value: "IRR: 11,9%\nNPV: USD 23.14 Million",
            // },
            // {
            //   title: "Downstream Phase – Bekasi City",
            //   value: "IRR: 11,8%\nNPV: USD 12.89 Million",
            // },
            // {
            //   title: "Downstream Phase – Bekasi Regency",
            //   value: "IRR: 12,1%\nNPV: USD 28.71 Million",
            // },
            // {
            //   title: "Downstream Phase – Bogor Regency",
            //   value: "IRR: 11,7%\nNPV: USD 27.66 Million",
            // },
            {
              title: "Estimated Concession Period",
              value: item.concessionPeriod === "Not Disclosed" ? item.concessionPeriod : `${item.concessionPeriod} years`,
            },
          ],
        },
        // {
        //   key: 1,
        //   title: "Project Digest Statistics",
        //   data: [
        //     { title: "Estimated Project Cost", value: "USD 1,180 Million" },
        //     {
        //       title: "Financial Feasibility",
        //       value: "Upstream Phase\nIRR: 10,7%\nNPV: USD 33.87 Million",
        //     },
        //   ],
        // },
        {
          key: 2,
          title: "Maps",
          data: [
            { title: "Estimated Project Cost", value: "USD 1,180 Million" },
            {
              title: "Financial Feasibility",
              value: "Upstream Phase\nIRR: 10,7%\nNPV: USD 33.87 Million",
            },
          ],
        },
        {
          key: 3,
          title: "Contact Information",
          data: [
            {
              title: "Name",
              value: item.contactName
                ? item.contactName
                : "Annisa Dian Pratiwi",
            },
            {
              title: "Email",
              value: item.contactEmail
                ? item.contactEmail
                : "annisa.pratiwi@pu.go.id",
            },
          ],
        },
      ];
      if (item.key === "1") {
        data.push({
          key: 1,
          title: "Project Digest Statistics",
          data: [
            { title: "Estimated Project Cost", value: "USD 1,180 Million" },
            {
              title: "Financial Feasibility",
              value: "Upstream Phase\nIRR: 10,7%\nNPV: USD 33.87 Million",
            },
          ],
        });
      }
      let newData = data.sort(function (a: any, b: any) {
        return a.key - b.key;
      });
      setPanelList(newData);
    }
  }, []);

  const updateImages = (data: any) => {
    if (data && data.categories) {
      filteredProjects = InvestmentHubData.filter((project: any) =>
        project.categories.some(
          (category: any) => category.name === data.categories[0].name
        )
      );

      setImages(filteredProjects.map((project: any) => project.image));
    }
  };

  const leadingBanks = (
    <Typography.Title level={5}>Leading Banks</Typography.Title>
  );

  return (
    <>
      <MainHeader
        title={"DECARB PROJECTS HUB"}
        imageSrc={InvestImg}
        text={
          "A hub to support and engage investors and infra owners/developers across sectors to access impact funds digitally. The decarb projects hub will offer investors access to project data and generate investible project names."
        }
      />{" "}
      <Row justify="center" className={"investment-hub-detail"}>
        <Col lg={20} style={{ margin: "1.5rem 0 0 0" }} offset={2}>
          <Breadcrumb>
            <Breadcrumb.Item>
              <Icon
                icon="ic:outline-home"
                height="20"
                onClick={() => navigate("/")}
                style={{
                  margin: "auto",
                  color: styles.strawberry,
                  cursor: "pointer",
                }}
              />
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <a onClick={() => navigate("/investment-hub")}>
                Decarb Projects Hub
              </a>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {filteredItem && filteredItem.title}
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
        <Col lg={20} style={{ margin: "3.5rem 0 0 0" }} offset={2}>
          <Row>
            <Col lg={10} style={{ maxHeight: 500 }}>
              <Swiper
                spaceBetween={10}
                navigation={true}
                thumbs={{ swiper: thumbsSwiper }}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper2"
              >
                {/* {InvestmentHubData &&
                  <ImageList projects={InvestmentHubData} categoryName="Utility" />
                } */}
                {/* <SwiperSlide>
                  <img src={filteredItem.image} />
                </SwiperSlide> */}
                {images.map((image: any, index: any) => (
                  <>
                    <SwiperSlide key={`slide-${index}`}>
                      <img src={image} />
                    </SwiperSlide>
                  </>
                ))}
                {/* <SwiperSlide>
                  <img src={filteredItem.image} />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-2.jpg" />
                </SwiperSlide> */}
                {/*
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-3.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-4.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-5.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-6.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-7.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-8.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-9.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-10.jpg" />
                </SwiperSlide> */}
              </Swiper>
              <Swiper
                onSwiper={(swiper: any) => setThumbsSwiper(swiper)}
                spaceBetween={10}
                slidesPerView={4}
                freeMode={true}
                watchSlidesProgress={true}
                modules={[FreeMode, Navigation, Thumbs]}
                className="mySwiper"
              >
                {images.map((image: any, index: any) => (
                  <>
                    <SwiperSlide key={`newSlide-${index}`}>
                      <img src={image} />
                    </SwiperSlide>
                  </>
                ))}

                {/* <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-2.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-3.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-4.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-5.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-6.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-7.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-8.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-9.jpg" />
                </SwiperSlide>
                <SwiperSlide>
                  <img src="https://swiperjs.com/demos/images/nature-10.jpg" />
                </SwiperSlide> */}
              </Swiper>
            </Col>
            <Col lg={14} style={{ paddingLeft: 40 }}>
              <div style={{ height: "100%" }}>
                <Typography.Title level={3}>
                  {filteredItem && (
                    <Typography.Text>{filteredItem.title}</Typography.Text>
                  )}{" "}
                </Typography.Title>
                <Typography.Title level={5}>Description</Typography.Title>{" "}
                <br />
                {filteredItem && (
                  <Typography.Text>
                    {filteredItem.description ? (
                      <div
                        dangerouslySetInnerHTML={{
                          __html: filteredItem.description,
                        }}
                      ></div>
                    ) : (
                      "Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum"
                    )}
                  </Typography.Text>
                )}
                <div>
                  <Row style={{ marginTop: "1rem" }}>
                    <Col span={12}>
                      <Icon
                        icon={"carbon:percentage"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        // className="textItemCenter"
                        style={{
                          color: "#003087",
                          textAlign: "center",
                          fontWeight: 600,
                        }}
                      >
                        Investable Rating:
                        {filteredItem &&
                          ` ${filteredItem.InvestableRating} / 100`}
                      </Typography.Text>
                    </Col>
                    <Col span={12}>
                      <Icon
                        icon={"simple-line-icons:location-pin"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        style={{
                          color: "#003087",
                          textAlign: "center",
                        }}
                      >
                        {filteredItem && ` ${filteredItem.Location}`}
                      </Typography.Text>
                    </Col>
                  </Row>

                  <Row style={{ marginTop: "1rem" }}>
                    <Col span={12}>
                      <Icon
                        icon={"ic:round-star-border"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        style={{
                          color: "#003087",
                          textAlign: "center",
                        }}
                      >
                        <span style={{ fontWeight: 600 }}>ESG Rating:</span>
                        {filteredItem && ` ${filteredItem.ESGRating} / 5`}
                      </Typography.Text>
                    </Col>
                    <Col span={12}>
                      <Icon
                        icon={"ic:outline-email"}
                        style={{
                          marginRight: "1rem",
                          color: "#525252",
                          textAlign: "center",
                          fontSize: 25,
                        }}
                      />
                      <Typography.Text
                        style={{
                          color: "#003087",
                          textAlign: "center",
                        }}
                      >
                        {filteredItem.contactEmail
                          ? filteredItem.contactEmail
                          : "annisa.pratiwi@pu.go.id"}
                      </Typography.Text>
                    </Col>
                  </Row>
                  {filteredItem.source && (
                    <Row style={{ marginTop: "1rem" }}>
                      <Col span={24}>
                        <Icon
                          icon={"mdi:source-pull"}
                          style={{
                            marginRight: "1rem",
                            color: "#525252",
                            textAlign: "center",
                            fontSize: 25,
                          }}
                        />
                        <Typography.Text
                          style={{
                            color: "#003087",
                            textAlign: "center",
                          }}
                        >
                          <span style={{ fontWeight: 600 }}>Source:</span>
                          {filteredItem && ` ${filteredItem.source}`}
                        </Typography.Text>
                      </Col>
                    </Row>
                  )}
                </div>
                <Row
                  style={{
                    // display: 'flex',
                    // justifyContent: 'flex-end',
                    marginTop: 30,
                  }}
                  className="textTextItemCenter"
                >
                  <Col span={12}>
                    <Space>
                      Share:
                      <Space>
                        <Col span={8}>
                          <Icon
                            icon={"logos:facebook"}
                            style={{
                              marginRight: "1rem",
                              color: "#525252",
                              fontSize: 25,
                            }}
                          />
                        </Col>
                        <Col span={8}>
                          <Icon
                            icon={"logos:pinterest"}
                            style={{
                              marginRight: "1rem",
                              color: "#525252",
                              fontSize: 25,
                            }}
                          />
                        </Col>
                        <Col span={8}>
                          <Icon
                            icon={"icon-park:twitter"}
                            style={{
                              marginRight: "1rem",
                              color: "#525252",
                              fontSize: 25,
                            }}
                          />
                        </Col>
                      </Space>
                    </Space>
                  </Col>
                  <Col span={12}>
                    <Button style={{ padding: 20 }}>
                      <Space>
                        <Typography.Text
                          style={{
                            color: "#00338D",
                          }}
                        >
                          I am Interested in this Project
                        </Typography.Text>
                        <Icon icon={"bx:like"} color="#AB0D82"></Icon>
                      </Space>
                    </Button>
                    <Button style={{ padding: 20, backgroundColor: "#00338D", marginTop: 10, width: 248 }}>
                      <Space>
                        <Typography.Text
                          style={{
                            color: "#FFFFFF",
                          }}
                          onClick={() => navigate("/financing-products")}
                        >
                          Explore Financing Options
                        </Typography.Text>
                      </Space>
                    </Button>
                  </Col>
                </Row>
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={24}>
              <Row>
                <Col lg={7} style={{ margin: "0.3rem 0" }}>
                  {/* <Card style={{ width: '100%', borderRadius: '15px' }}>
                                        <Space>
                                            <div style={{ borderRadius: '50%', backgroundColor: 'yellow', padding: '0.7rem', marginRight: '1rem' }}>
                                                <HomeOutlined style={{ fontSize: '20px' }} />
                                            </div>
                                            <Typography.Title level={5}>lorem isu</Typography.Title>
                                        </Space>
                                        <Space direction="vertical" style={{ marginTop: '1rem' }}>
                                            <Typography.Text><PercentageOutlined style={{ marginRight: '1rem' }} />unknown printer took</Typography.Text>
                                            <Typography.Text><StarOutlined style={{ marginRight: '1rem' }} />unknown printer took</Typography.Text>
                                            <Typography.Text><EnvironmentOutlined style={{ marginRight: '1rem' }} />unknown printer took</Typography.Text>
                                        </Space>
                                        <div style={{ textAlign: 'right', margin: '1rem 0 0 0' }}>
                                            <Button size="small" style={{ padding: '0.7rem' }}>Details</Button>
                                        </div>
                                    </Card> */}
                </Col>
              </Row>
            </Col>
          </Row>
        </Col>
      </Row>
      <DetailView item={filteredItem} />
      <Row justify="center">
        <Col lg={20} style={{ margin: "3.5rem 0 0 0" }} offset={2}>
          <AccordionTable panels={panelList} item={filteredItem} />
        </Col>
      </Row>
      {/* <Col md={2} style={{ display: 'flex', textAlign: 'center', alignItems: 'center' }}> */}
      <Row>
        <Col lg={2}></Col>
        <Col lg={20} style={{ margin: "3.5rem 0 0 0" }} offset={2}>
          <Typography.Title level={4}>Related Projects</Typography.Title>
        </Col>
        <Col lg={2}></Col>
      </Row>
      {/* </Col> */}
      <RelatedProjects logos={InvestmentHubData}></RelatedProjects>
      <LogoGallery element={leadingBanks} />
      <AppFooter />
    </>
  );
};
